import { Grid } from '@mantine/core';

import { TextInput } from '@components';
import { useDeclarant, useGoodLocation } from '@hooks/declarant';
import { FieldRow, PolicyArrayField, PolicyField, useFinalizeFieldRules } from '../../policy';

interface TransportDetailsProps {
  disabled: boolean;
}

export const TransportDetails: React.FC<TransportDetailsProps> = ({ disabled }) => {
  const { form, rule, fieldProps } = useFinalizeFieldRules({ section: 'transport' });
  const { data: declarant } = useDeclarant();
  const { data: { data: goodsLocations } = {} } = useGoodLocation(declarant?._id);

  const containerHeader = form.values.transportInformation.transportEquipment.header as boolean;

  return (
    <>
      <FieldRow mb="sm">
        <PolicyField {...fieldProps('transportInformation.departureTransportMeans.identificationNumber')} span={4} />
        <PolicyField {...fieldProps('transportInformation.departureTransportMeans.typeOfIdentification')} span={4} />
        <PolicyField {...fieldProps('transportInformation.departureTransportMeans.nationality')} span={4} />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyField {...fieldProps('transportInformation.activeBorderTransportMeans.identificationNumber')} span={3} />
        <PolicyField {...fieldProps('transportInformation.activeBorderTransportMeans.typeOfIdentification')} span={3} />
        <PolicyField {...fieldProps('transportInformation.activeBorderTransportMeans.nationality')} span={3} />
        <PolicyField {...fieldProps('transportInformation.modeOfTransportMeansAtTheBorder')} span={3} />
      </FieldRow>

      {rule('loadingPlaceIdentity').present && (
        <FieldRow mb="sm">
          <Grid.Col span={12}>
            <TextInput
              label={rule('loadingPlaceIdentity').label}
              defaultValue={goodsLocations?.find((location) => location.unLocode === form.values.consignment.locationOfGoods.unLocode)?.address?.city}
              size="lg"
              disabled
              data-pw={rule('loadingPlaceIdentity').dataPw}
            />
          </Grid.Col>
        </FieldRow>
      )}

      <FieldRow mb="sm">
        <PolicyField {...fieldProps('transportInformation.arrivalTransportMeans.identificationNumber')} span={4} />
        <PolicyField {...fieldProps('transportInformation.arrivalTransportMeans.typeOfIdentification')} span={4} />
        <PolicyField {...fieldProps('transportInformation.inlandModeOfTransport')} span={4} />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyArrayField
          {...fieldProps('transportInformation.transportEquipment.containers')}
          span={6}
          eucdmPath="transportInformation.transportEquipment.containers"
          addButtonLabel="Add Container"
          disabledWhen={!containerHeader}
        />
      </FieldRow>

      <FieldRow mb="sm">
        <PolicyArrayField
          {...fieldProps('transportInformation.countryOfRoutingOfConsignment')}
          span={12}
          eucdmPath="transportInformation.countryOfRoutingOfConsignment.country"
        />
      </FieldRow>
    </>
  );
};
